module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', [_c('v-subheader', {
    staticClass: "title"
  }, [_vm._v("PROFIL UŻYTKOWNIKA")]), _vm._v(" "), _c('v-card-title', [_c('div', [_c('v-text-field', {
    staticClass: "rozmiar",
    attrs: {
      "label": "E-mail"
    },
    model: {
      value: (_vm.Profile.email),
      callback: function($$v) {
        _vm.$set(_vm.Profile, "email", $$v)
      },
      expression: "Profile.email"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "rozmiar",
    attrs: {
      "label": "Imię i Nazwisko"
    },
    model: {
      value: (_vm.Profile.displayName),
      callback: function($$v) {
        _vm.$set(_vm.Profile, "displayName", $$v)
      },
      expression: "Profile.displayName"
    }
  })], 1)]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    on: {
      "click": function($event) {
        _vm.updateProfile()
      }
    }
  }, [_vm._v("Aktualizuj profil")])], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": 6000,
      "top": true,
      "bottom": false,
      "right": false,
      "left": false,
      "multi-line": false,
      "vertical": true
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.message) + "\n    "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "pink"
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("Close")])], 1), _vm._v(" "), (_vm.ready) ? _c('div', {
    staticClass: "overlay"
  }, [_c('div', {
    staticClass: "flex-spinner"
  }, [_c('v-progress-circular', {
    attrs: {
      "size": 200,
      "width": 7,
      "indeterminate": "",
      "color": "amber"
    }
  })], 1)]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66914a9d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/UpdateProfile.vue
// module id = 158
// module chunks = 1